import React from "react";
import { NormalizedNutritionV2 } from "../type";
import TileGrid from "./TileGrid";
import { ReadOnlyFieldConfig } from "../ReadOnlyField";

type Props = {
  data: NormalizedNutritionV2;
  openPopperId: string | null;
  setOpenPopperId: React.Dispatch<React.SetStateAction<string | null>>;
};

const EatingHabitsTab = ({ data, openPopperId, setOpenPopperId }: Props) => {
  const { eatingHabits } = data;

  // Row-major: the three cheat-meal tiles read across row 1, the three
  // drink tiles across row 2, and the coffee recipe wraps to row 3. Was three
  // column stacks, which interleaved cheat and drink tiles vertically.
  const tiles: ReadOnlyFieldConfig[] = [
    {
      label: "Cheat meals",
      value: eatingHabits.cheatMeals,
      fieldKey: "cheat-meals",
    },
    {
      label: "Typical cheat days",
      value: eatingHabits.cheatDays,
      fieldKey: "typical-cheat-days",
    },
    {
      label: "Favourite cheat meals",
      value:
        eatingHabits.favouriteCheatMeals.length > 0
          ? eatingHabits.favouriteCheatMeals.join(", ")
          : "No",
      fieldKey: "favourite-cheat-meals",
      items: eatingHabits.favouriteCheatMeals.map((name) => ({
        name,
        preferred: true,
      })),
    },
    {
      label: "Alcohol intake",
      value: eatingHabits.alcoholIntake,
      fieldKey: "alcohol-intake",
    },
    {
      label: "Preferred drinks",
      value:
        eatingHabits.preferredDrinks.length > 0
          ? eatingHabits.preferredDrinks.join(", ")
          : "No",
      fieldKey: "preferred-drinks",
      items: eatingHabits.preferredDrinks.map((name) => ({
        name,
        preferred: true,
      })),
    },
    {
      label: "Coffee",
      value: eatingHabits.coffeeIntake,
      fieldKey: "coffee-intake",
    },
    {
      label: "How they drink coffee",
      value: eatingHabits.coffeeRecipe,
      fieldKey: "coffee-recipe",
    },
  ];

  return (
    <TileGrid
      tiles={tiles}
      openPopperId={openPopperId}
      setOpenPopperId={setOpenPopperId}
    />
  );
};

export default EatingHabitsTab;
